import { render } from "./ZoomInPictureModal.vue?vue&type=template&id=70815b20&scoped=true"
import script from "./ZoomInPictureModal.vue?vue&type=script&lang=js"
export * from "./ZoomInPictureModal.vue?vue&type=script&lang=js"

import "./ZoomInPictureModal.vue?vue&type=style&index=0&id=70815b20&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70815b20"]])

export default __exports__